var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisibleOnFeatureSwitch)?_c('button',{ref:"buttonActionRibbon",class:[
		'btn-action-ribbon',
		..._vm.variantClassList,
		..._vm.stateClassList,
		_vm.disabled && 'is-disabled',
		_vm.hasUnsavedChanges && 'has-unsaved-changes',
		_vm.disabled
			? 'is-disabled'
			: _vm.isLoading
			? 'is-disabled'
			: _vm.hasLoaded
			? 'is-disabled'
			: '',
		_vm.isLoading && 'is-loading',
		_vm.hasLoaded && 'has-loaded'
	],attrs:{"id":_vm.uid,"title":_vm.title,"disabled":_vm.disabled,"type":_vm.type},on:{"click":_vm.onClick,"mouseenter":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"focus":_vm.onMouseEnter,"blur":_vm.onBlur}},[(_vm.iconClassName.length > 0)?_c('span',{staticClass:"btn-action-ribbon__icon"},[_c('i',{staticClass:"icon",class:_vm.iconClassName}),_c('Badge',{staticClass:"btn-action-ribbon__unsave-changes-badge",attrs:{"visible":_vm.hasUnsavedChanges,"state":"negative","variant":"pill","text":_vm.badgeText}})],1):_vm._e(),_vm._t("default",function(){return [(_vm.labelText)?_c('span',{staticClass:"btn-action-ribbon__label",attrs:{"data-id":"label-text"}},[_vm._v(" "+_vm._s(_vm.labelText)+" ")]):_vm._e()]}),_c('Tooltip',{attrs:{"placement":"right","visible":_vm.displayTooltip,"trackedRefName":"buttonActionRibbon","positionStrategy":"fixed"}},[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")]),_c('ButtonProgress',{attrs:{"isLoading":_vm.isLoading,"hasLoaded":_vm.hasLoaded,"hasError":_vm.hasError,"errorMessage":_vm.errorMessage}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }